import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import "../styles/gptBooks.scss";
import {
  alphaLoader,
  homeBanner,
  imgAdd,
  markModal,
  medicalModal,
  micActive,
  micInactive,
  physicalModal,
  ssbBook,
  volumeActive,
  volumeInactive,
} from "../assets/images";
import { useAuth } from "alpha-ui";
import bookService from "../services/bookService";
import PopupPrompt from "./reusable/PopupPrompt";
import { toast } from "react-toastify";
import { RiArrowDropDownLine, RiArrowDropUpLine } from "react-icons/ri";
import { RxCross2 } from "react-icons/rx";
import ButtonLoader from "./reusable/ButtonLoader";
import stretching from "../images/icons/stretching.png";
// import bicycle from "../images/icons/bicycle.png";
import classroom from "../images/icons/classroom.png";
// import run from "../images/icons/run.png";
import notes from "../images/icons/notes.png";
import logo_mobile_small from "../images/logo_mobile.png";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import { IoInformationCircleOutline } from "react-icons/io5";

const GptBooks = ({
  bookList,
  fetchBookList,
  handleSave,
  outputData,
  handleShowHistory,
  questionList,
  activeCaptain,
  handleMicFunction,
  handleSpeakFunction,
  gptMic,
  gptSpeaker,
  loadingNotes,
  handleShowClassroom,
  handleShowExercise,
  showBook,
  setShowBook,
  handleShowNotes,
  showExerciseBar,
  showChatBox,
}) => {
  const {auth} = useAuth();
  const divRef = useRef(null);
  const [addBook, setAddBook] = useState(false);
  const [bookName, setBookName] = useState("");
  const [newBookLoading, setNewBookLoading] = useState(false);

  const [addChapter, setAddChapter] = useState(false);
  const [chapterBook, setChapterBook] = useState("");
  const [chapterId, setChapterId] = useState("");
  const [chapterName, setChapterName] = useState("");
  const [saveIndex, setSaveIndex] = useState(0);
  const [chapterModal, setChapterModal] = useState(false);
  const [bookChapterList, setBookChapterList] = useState();
  const [showHistory, setShowHistory] = useState(false);

  const [chapterLoading, setChapterLoading] = useState(false);
  const [viewHistory, setViewHistory] = useState(false);
  const [captainImage, setCaptainImage] = useState("");
  const [captainName, setCaptainName] = useState("");
  const [captainDesc, setCaptainDesc] = useState("");

  // BOOK STATE HANDLING STARTS
  const handleAddChapter = () => {
    setAddChapter(true);
    setChapterModal(false);
  };

  const [saveUnit, setSaveUnit] = useState(false);

  const addNewUnit = async () => {
    setNewBookLoading(true);
    const data = outputData?.find((_, id) => saveIndex === id);
    const type = "text";
    try {
      const res = await bookService.addNewChapterData(chapterId, type, data);
      if (res?.data?.success) {
        setSaveUnit(false);
        setChapterBook("");
        setChapterId("");
        setNewBookLoading(false);
        toast.success(res?.data?.message);
      } else {
        toast.error(res?.data?.message);
        setSaveUnit(false);
        setChapterBook("");
        setChapterId("");
        setNewBookLoading(false);
      }
    } catch (error) {
      toast.error(error?.message)
      console.log("error", error)
      setNewBookLoading(false);
      setSaveUnit(false);
    }
  };

  // ADD NEW BOOK ENDS

  const optionBookList = useMemo(() => {
    return bookList?.map((ele) => ({
      option: ele?.name,
      value: ele?._id,
    }));
  }, [bookList]);

  const chapterListFromBookId = useMemo(() => {
    return bookChapterList?.chapters?.map((ele) => ({
      option: ele?.name,
      value: ele?._id,
    }));
  }, [bookChapterList]);

  // ADD NEW CHAPTER STARTS
  useEffect(() => {
    if (handleSave) {
      setSaveIndex(handleSave);
      setSaveUnit(true);
    }
  }, [handleSave]);

  const handleAddNewChapter = async () => {
    setNewBookLoading(true);
    try {
      const res = await bookService.addNewChapter(chapterBook, chapterName);
      if (res?.data?.success) {
        setAddChapter(false);
        setChapterBook("");
        setNewBookLoading(false);
        toast.success(res?.data?.message);
      } else {
        toast.error(res?.data?.message);
        setAddChapter(false);
        setChapterBook("");
        setNewBookLoading(false);
      }
    } catch (error) {
      setNewBookLoading(false);
      setAddChapter(false);
    }
  };

  const openBook = (id) => {
    getChapterListBybookId(id);
  };

  const getChapterListBybookId = async (id) => {
    setChapterBook(id);
    setChapterLoading({
      loading: true,
      index: id,
    });
    try {
      const res = await bookService.myAllChapterbyBookid(id);
      if (res?.data?.success) {
        setChapterModal(true);
        setShowBook(false);
        setBookChapterList(res?.data);
        setChapterLoading(false);
      }
    } catch (error) {
      setShowBook(false);
      setChapterLoading(false);
    }
  };

  // GET CHAPTER LIST BY BOOK ID

  useEffect(() => {
    if (chapterBook !== "") {
      getChapterListBybookId(chapterBook);
    }
  }, [chapterBook]);

  const handleAddnewBook = async () => {
    setNewBookLoading(true);
    try {
      const res = await bookService.createUserNewBook(bookName);
      if (res?.data) {
        toast.success("Book Add Successfully");
        setNewBookLoading(false);
        fetchBookList();
        setBookName("");
        setAddBook(false);
      }
    } catch (error) {
      setNewBookLoading(false);
      setBookName("");
      setAddBook(false);
    }
  };

  const handleAddBookModal = () => {
    if (auth?.user?._id) {
      setAddBook(true);
    } else {
      toast.error("Login before adding new book");
    }

    setShowBook(false);
  };

  useEffect(() => {
    if (
      activeCaptain === "question" ||
      activeCaptain === "Lecturette" ||
      activeCaptain === "oir-test" ||
      activeCaptain === "group-discussion" ||
      activeCaptain === "mock-psychology" ||
      activeCaptain === "mock-PPDT" ||
      activeCaptain === "ssb-gto" ||
      activeCaptain === "olq-analysis" ||
      activeCaptain === "mock-interview" ||
      activeCaptain === "current-affair"
    ) {
      setCaptainImage(homeBanner);
      setCaptainName("Arjun Rathore");
      setCaptainDesc("AI CDS Mentor");
    } else if (activeCaptain === "medical") {
      setCaptainImage(medicalModal);
      setCaptainName("Ravinder Yadav");
      setCaptainDesc("AI Medical Expert");
    } else if (activeCaptain === "physical") {
      setCaptainImage(physicalModal);
      setCaptainName("Vikram Kumar");
      setCaptainDesc("AI Fitness Trainer");
    } else if (activeCaptain === "spoken-english") {
      setCaptainImage(markModal);
      setCaptainName("Mark");
      setCaptainDesc("AI Spoken English Trainer");
    } else {
      setCaptainImage(alphaLoader);
      setCaptainName("INET-GPT");
      setCaptainDesc("INET self preparation tool");
    }
  }, [activeCaptain]);

  return (
    <Fragment>
      <div className="gpt_books_wrapper">
        <div className="chat_modal_type">
          <img
            src={captainImage}
            alt="captain modal"
            className="modal_picture"
          />
          <h2>{captainName}</h2>
          <p>{captainDesc}</p>
          <div className="btn_grps">
            {activeCaptain !== "" && activeCaptain !== "Lecturette" ? (
              <>
                <button onClick={handleMicFunction}>
                  <img
                    src={gptMic ? micActive : micInactive}
                    alt="mic button"
                  />
                </button>
                <button onClick={handleSpeakFunction}>
                  <img
                    src={gptSpeaker ? volumeActive : volumeInactive}
                    alt="volume button"
                  />
                </button>
              </>
            ) : (
              <>
                <Link
                  to="https://www.instagram.com/ssbgpt/"
                  target="_blank"
                  title="Instagram"
                  rel="nofollow noopener"
                >
                  <FaInstagram />
                </Link>
                <Link
                  to="https://www.youtube.com/@SSBGPT"
                  target="_blank"
                  title="Youtube"
                  rel="nofollow noopener"
                >
                  <FaYoutube />
                </Link>
                <Link
                  to="https://www.linkedin.com/company/ssb-gpt/"
                  target="_blank"
                  title="Linkedin"
                  rel="nofollow noopener"
                >
                  <FaLinkedin />
                </Link>
                <Link
                  to="https://www.facebook.com/profile.php?id=61568516845347"
                  target="_blank"
                  title="Facebook"
                  rel="nofollow noopener"
                >
                  <FaFacebookF />
                </Link>
                <Link
                  to="https://x.com/ssbgpt"
                  target="_blank"
                  title="Twitter"
                  rel="nofollow noopener"
                >
                  <FaTwitter />
                </Link>
              </>
            )}
          </div>
        </div>
        <div className="notes_content">
          <div className="title_get">
            <div className="title">
              <h2>
                Notes{" "}
                <span>
                  <IoInformationCircleOutline />
                </span>
              </h2>
              <a className="binaural" href="/inetgpt/notes-instructions">
                Know, What is Notes?
              </a>
            </div>
          </div>

          <ul className="custonScroll">
            {loadingNotes ? (
              <ButtonLoader color="#f2f2f2" />
            ) : (
              bookList?.map((ele) => (
                <li key={ele?._id} onClick={() => openBook(ele?._id)}>
                  <div className="book_tab">
                    <img src={ssbBook} alt="ssb_book" />
                    <p>
                      {chapterLoading?.loading &&
                      chapterLoading?.index === ele?._id
                        ? "Loading.."
                        : ele?.name}
                    </p>
                  </div>
                </li>
              ))
            )}
            {!loadingNotes && (
              <li>
                <div
                  className="book_tab"
                  onClick={() => handleAddBookModal(true)}
                >
                  <img src={imgAdd} alt="imgAdd" />
                  <p>Add New</p>
                </div>
              </li>
            )}
          </ul>
        </div>
      </div>

      <section className="mobile_bar_content">
        <div className="container">
          <div className="mobile_navigation">
            <span
              className={`stretching ${showExerciseBar ? "active" : ""}`}
              onClick={() => handleShowExercise()}
            >
              <img src={stretching} alt="stretching" />
              Workout
            </span>
            {/* <span className="bicycle">
              <img src={bicycle} alt="bicycle" />
              Cycling
            </span> */}
            <span
              className={`classroom ${showChatBox ? "active" : ""}`}
              onClick={() => handleShowClassroom()}
            >
              <img src={classroom} alt="classroom" />
              Classroom
            </span>
            {/* <span className="run">
              <img src={run} alt="run" />
              Running
            </span> */}
            <span
              className={`notes ${showBook ? "active" : ""}`}
              onClick={() => handleShowNotes()}
            >
              <img src={notes} alt="notes" />
              Notes
            </span>
            {/* <span onClick={() => setShowHistory(true)}>History</span> */}
          </div>
        </div>

        <div className={`book_list ${showBook ? "book_list_show" : ""}`}>
          <div className="gpt_books">
            <div className="title">
              <h2>Notes</h2>
              <span onClick={() => setShowBook(false)}>
                <RxCross2 />
              </span>
            </div>
            <ul>
              {bookList?.map((ele) => (
                <li key={ele?._id}>
                  <div
                    className="book_tab"
                    onClick={() => getChapterListBybookId(ele?._id)}
                  >
                    <img src={ssbBook} alt="ssb_book" />
                    <p>
                      {chapterLoading?.loading &&
                      chapterLoading?.index === ele?._id
                        ? "Loading.."
                        : ele?.name}
                    </p>
                  </div>
                </li>
              ))}
              <li>
                <div className="book_tab" onClick={() => handleAddBookModal()}>
                  <img src={imgAdd} alt="imgAdd" />
                  <p>Add New</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div
          className={`history_list ${showHistory ? "history_list_show" : ""}`}
        >
          <div className="gpt_books">
            <div className="title">
              <h2>Search History</h2>
              <span onClick={() => setShowHistory(false)}>
                <RxCross2 />
              </span>
            </div>
            <ul>
              {questionList?.length > 0 ? (
                questionList?.map((ele, id) => (
                  <li key={id} onClick={() => setViewHistory(!viewHistory)}>
                    <p>
                      {ele?.dayData}
                      {!viewHistory ? (
                        <RiArrowDropDownLine />
                      ) : (
                        <RiArrowDropUpLine />
                      )}
                    </p>

                    {viewHistory && (
                      <span onClick={() => handleShowHistory(ele?.dayData)}>
                        {ele?.searchData?.map((item, id) => (
                          <p key={id}>
                            {id + 1}. {item?.question}
                          </p>
                        ))}
                      </span>
                    )}
                  </li>
                ))
              ) : (
                <li>
                  <p>No search history found</p>
                </li>
              )}
            </ul>
          </div>
        </div>
      </section>

      {addBook && (
        <PopupPrompt
          divRef={divRef}
          cancelBtnTxt="Cancel"
          cancelOnclick={() => setAddBook(false)}
          confirmBtnTxt="Save Note"
          confirmOnclick={() => handleAddnewBook()}
          title="Add Your New Note"
          newBookPlaceholder="Write your Note name"
          newBookLabel="Note Name"
          newbookValue={bookName}
          loading={newBookLoading}
          onNewBookChange={(e) => setBookName(e.target.value)}
        />
      )}

      {addChapter && (
        <PopupPrompt
          divRef={divRef}
          cancelBtnTxt="Cancel"
          cancelOnclick={() => setAddChapter(false)}
          confirmBtnTxt="Save Chapter"
          confirmbtnWidth="140px"
          confirmOnclick={() => handleAddNewChapter()}
          title="Save Chapter"
          // newChapterPlaceholder="Select your Note"
          // newChapterLabel="Note Name"
          // newChapterValue={chapterBook}
          // loading={newBookLoading}
          // bookOption={optionBookList}
          // onNewChapterChange={(e) => setChapterBook(e.target.value)}
          onNewChapterNameChange={(e) => setChapterName(e.target.value)}
          newChapterNamePlaceholder="Enter your chapter name"
          newChapterNameLabel="Chapter Name"
          newChapterNameValue={chapterName}
        />
      )}

      {saveUnit && (
        <PopupPrompt
          divRef={divRef}
          cancelBtnTxt="Cancel"
          cancelOnclick={() => setSaveUnit(false)}
          confirmBtnTxt="Save Topic"
          confirmbtnWidth="140px"
          confirmOnclick={() => addNewUnit()}
          title="Add Chapter"
          newChapterPlaceholder="Select your Note name"
          newChapterLabel="Note Name"
          newChapterValue={chapterBook}
          loading={newBookLoading}
          bookOption={optionBookList}
          onNewChapterChange={(e) => setChapterBook(e.target.value)}
          onChapterIdChange={(e) => setChapterId(e.target.value)}
          chapterIdPlaceholder="Select your chapter name"
          chapterIdLabel="Chapter Name"
          chapterIdValue={chapterId}
          chapterOption={chapterListFromBookId}
        />
      )}

      {chapterModal && (
        <PopupPrompt
          ref={divRef}
          confirmBtnTxt="Add Chapter"
          confirmbtnWidth="160px"
          confirmOnclick={() => handleAddChapter()}
          cancelBtnTxt="Close List"
          cancelOnclick={() => setChapterModal(false)}
          title={"Chapter List"}
          chapterData={bookChapterList?.chapters}
        />
      )}
    </Fragment>
  );
};

export default GptBooks;
